import styled from "styled-components";
import { Tab } from "@renderbus/ui";
import { VerificationSettingEchoEnum } from "./constant";
import { useChildIntergrationSettingEcho } from "./hooks/useChildIntergrationSettingEcho";
import { useDingTalkSubAccountStore } from "../../store/dingtalk-subaccount-store";

export function ChildIntegrationEchoSetting() {
  const { defaultVerificationChildTabsList } =
    useChildIntergrationSettingEcho();
  const { setOpenSettingModal } = useDingTalkSubAccountStore();
  return (
    <ChildIntegrationSettingContainer>
      <Tab
        defaultActiveKey={VerificationSettingEchoEnum.SETTING}
        tabsList={defaultVerificationChildTabsList}
        tabBarExtraContent={
          <ChildEchoTabExchange onClick={() => setOpenSettingModal(false)} />
        }
      />
    </ChildIntegrationSettingContainer>
  );
}

const ChildIntegrationSettingContainer = styled.div`
  display: flex;
  flex-direction: column;
  .ant-tabs {
    background: #343538;
    .ant-tabs-extra-content {
      height: 50px;
      width: 60px;
      position: absolute;
      right: 0;
      top: 0;
    }
  }
  .integration-item-title {
    background: #1c1c21;
    line-height: 22px;
    padding: 10px 0;
    text-align: center;
    color: #d4d4d4;
    margin-bottom: 16px;
  }
`;
const ChildEchoTabExchange = styled.div`
  position: relative;
  width: 100%;
  &:after,
  :before {
    content: " ";
    position: absolute;
    top: 24px;
    right: 20px;
    background: #999999;
    width: 16px;
    height: 1px;
    cursor: pointer;
  }
  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
  }
`;
